import React from 'react'
import usePreferences from '@page-components/CheckoutV3/hooks/usePreferences.main'
import useSections from '@page-components/CheckoutV3/hooks/useSections'
import {useTranslation} from 'next-i18next'

import showTip from '../helpers/showTip'

import FixedTip from './FixedTip'
import PercentageTip from './PercentageTip'

export default function Tip() {
  const {t} = useTranslation('checkoutv3', {keyPrefix: 'payment.tip'})
  const {preferences} = usePreferences()
  const sections = useSections()

  if (!sections.includes('tip')) return null

  const {cart} = preferences
  const {hasFixedAmountTips} = cart

  if (!showTip(preferences)) return null

  return (
    <div className="px-4 py-0 md:py-2">
      <h3 className="font-medium text-sm  py-2">{t('header')}</h3>
      {hasFixedAmountTips ? <FixedTip /> : <PercentageTip />}
    </div>
  )
}
